export default __webpack_public_path__ + "homepage.css";